"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPendingTx = void 0;
const checkPendingTx = (address, abi) => ({
    title: 'Confirming previous transaction',
    tasks: [
        {
            ref: 'checkPendingTx',
            name: 'Checking your ongoing transaction',
            description: 'Checking your ongoing transaction',
            type: 'pending-tx',
            inputs: {
                address,
                abi,
            },
        },
    ],
});
exports.checkPendingTx = checkPendingTx;
//# sourceMappingURL=jobs.js.map